import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import SocialScreen from '../screens/social/SocialScreen';
import CreatePostScreen from '../screens/social/feed/CreatePostScreen';
import ChatRoomScreen from '../screens/social/chat/ChatRoomScreen';
import NewChatScreen from '../screens/social/chat/NewChatScreen';
import GroupInfoScreen from '../screens/social/chat/GroupInfoScreen';
import PostDetailScreen from '../screens/social/feed/PostDetailScreen';
import UserProfileScreen from '../screens/social/feed/UserProfileScreen';
import CreateGroupScreen from '../screens/social/chat/CreateGroupScreen';

const Stack = createStackNavigator();

const SocialNavigator = () => {
    return (
        <Stack.Navigator
            screenOptions={{
                headerStyle: {
                    backgroundColor: '#FFFFFF',
                },
                headerTintColor: '#111827',
                headerTitleStyle: {
                    fontWeight: 'bold',
                },
                headerShadowVisible: false,
            }}
        >
            <Stack.Screen
                name="SocialTabs"
                component={SocialScreen}
                options={{ headerShown: false }}
            />
            <Stack.Screen
                name="CreatePost"
                component={CreatePostScreen}
                options={{
                    presentation: 'modal',
                    headerShown: false
                }}
            />
            <Stack.Screen
                name="ChatRoom"
                component={ChatRoomScreen}
                options={{ headerShown: false }}
            />
            <Stack.Screen
                name="NewChat"
                component={NewChatScreen}
                options={{ headerShown: false }}
            />
            <Stack.Screen
                name="PostDetail"
                component={PostDetailScreen}
                options={{ headerShown: false }}
            />
            <Stack.Screen
                name="UserProfile"
                component={UserProfileScreen}
                options={{ headerShown: false }}
            />
            <Stack.Screen
                name="GroupInfo"
                component={GroupInfoScreen}
                options={{ headerShown: false }}
            />
            <Stack.Screen
                name="CreateGroup"
                component={CreateGroupScreen}
                options={{ headerShown: false }}
            />
        </Stack.Navigator>
    );
};

export default SocialNavigator;
